import { styled, Box } from '@mui/material'

export const HiCIcon = styled(Box)(({ theme }) => ({
  '*': {
    color: 'var(--DarkImperialBlue)',
    display: 'flex',
    textAlign: 'center',
  },
}))
